$(document).ready(function(e) {
    ImgIputHandler.Init();//初始化表情包ImgIputHandler.facePath
});

var ImgIputHandler={
	facePath:[
	    {faceName :'大笑',facePath :'face0'},
	    {faceName :'白眼',facePath :'face1'},
	    {faceName :'猪',facePath :'face2'},
	    {faceName :'微笑',facePath :'face3'},
	    {faceName :'害羞',facePath :'face4'},
	    {faceName :'可爱',facePath :'face5'},
	    {faceName :'色',facePath :'face6'},
	    {faceName :'飞吻',facePath :'face7'},
	    {faceName :'亲亲',facePath :'face8'},
	    {faceName :'调皮',facePath :'face11'},
	    {faceName :'吐舌头',facePath :'face12'},
	    {faceName :'发呆',facePath :'face14'},
	    {faceName :'龇牙',facePath :'face15'},
	    {faceName :'不屑',facePath :'face16'},
	    {faceName :'傲慢',facePath :'face17'},
	    {faceName :'鄙视',facePath :'face18'},
	    {faceName :'衰',facePath :'face19'},
	    {faceName :'难过',facePath :'face20'},
	    {faceName :'笑喷',facePath :'face22'},
	    {faceName :'流泪',facePath :'face23'},
	    {faceName :'折磨',facePath :'face24'},
	    {faceName :'冷汗',facePath :'face25'},
	    {faceName :'惊恐',facePath :'face26'},
	    {faceName :'流汗',facePath :'face27'},
	    {faceName :'尴尬',facePath :'face28'},
	    {faceName :'大哭',facePath :'face29'},
	    {faceName :'抓狂',facePath :'face30'},
	    {faceName :'害怕',facePath :'face32'},
	    {faceName :'愤怒',facePath :'face34'},
	    {faceName :'发怒',facePath :'face35'},
	    {faceName :'生病',facePath :'face39'},
	    {faceName :'得意',facePath :'face40'},
	    {faceName :'困',facePath :'face41'},
	    {faceName :'晕',facePath :'face43'},
	    {faceName :'委屈',facePath :'face44'},
	    {faceName :'坏笑',facePath :'face47'},
	    {faceName :'小恶魔',facePath :'face48'},
	    {faceName :'惊讶',facePath :'face49'},
	    {faceName :'闭嘴',facePath :'face51'},
	    {faceName :'撇嘴',facePath :'face52'},
	    {faceName :'酷',facePath :'face56'},
	    {faceName :'老板',facePath :'face58'},
	    {faceName :'跑腿小弟',facePath :'face64'},
	    {faceName :'跑堂小妹',facePath :'face65'},
	    {faceName :'天使',facePath :'face71'},
	    {faceName :'憨笑',facePath :'face74'},
	    {faceName :'阴险',facePath :'face77'},
	    {faceName :'吓',facePath :'face78'},
	    {faceName :'可怜',facePath :'face79'},
	    {faceName :'不要看',facePath :'face84'},
	    {faceName :'投降',facePath :'face85'},
	    {faceName :'偷笑',facePath :'face86'},
	    {faceName :'骷髅',facePath :'face87'},
	    {faceName :'外星人',facePath :'face88'},
	    {faceName :'屎',facePath :'face89'},
	    {faceName :'火焰',facePath :'face90'},
	    {faceName :'发光',facePath :'face91'},
	    {faceName :'星星',facePath :'face92'},
	    {faceName :'Bang！',facePath :'face94'},
	    {faceName :'雨水',facePath :'face96'},
	    {faceName :'睡觉',facePath :'face98'},
	    {faceName :'吹起',facePath :'face99'},
	    {faceName :'赞',facePath :'face105'},
	    {faceName :'真挫',facePath :'face106'},
	    {faceName :'拳头',facePath :'face108'},
	    {faceName :'耶',facePath :'face110'},
	    {faceName :'鼓掌',facePath :'face121'},
	    {faceName :'强',facePath :'face122'},
	    {faceName :'快跑',facePath :'face124'},
	    {faceName :'跳舞',facePath :'face125'},
	    {faceName :'男女',facePath :'face126'},
	    {faceName :'一家人',facePath :'face127'},
	    {faceName :'亲亲我我',facePath :'face130'},
	    {faceName :'兔女郎',facePath :'face132'},
	    {faceName :'OK',facePath :'face133'},
	    {faceName :'NO',facePath :'face134'},
	    {faceName :'举手',facePath :'face136'},
	    {faceName :'按摩',facePath :'face137'},
	    {faceName :'剪发',facePath :'face138'},
	    {faceName :'思考',facePath :'face143'},
	    {faceName :'王冠',facePath :'face145'},
	    {faceName :'比基尼',facePath :'face159'},
	    {faceName :'眼镜',facePath :'face164'},
	    {faceName :'礼物',facePath :'face165'},
	    {faceName :'雨伞',facePath :'face166'},
	    {faceName :'红心',facePath :'face172'},
	    {faceName :'心碎',facePath :'face173'},
	    {faceName :'心',facePath :'face176'},
	    {faceName :'丘比特',facePath :'face179'}
	]
	,
	Init:function(){
	},
	insertAtCursor:function(myField, myValue) {
    if (document.selection) {
        myField.focus();
        sel = document.selection.createRange();
        sel.text = myValue;
        sel.select();
    } else if (myField.selectionStart || myField.selectionStart == "0") {
        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        var restoreTop = myField.scrollTop;
        myField.value = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length);
        if (restoreTop > 0) {
            myField.scrollTop = restoreTop;
        }
        myField.focus();
        myField.selectionStart = startPos + myValue.length;
        myField.selectionEnd = startPos + myValue.length;
    } else {
        myField.value += myValue;
        myField.focus();
    }
}
}

